"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangePicker = void 0;
var react_1 = __importStar(require("react"));
var RadioAndCheckbox_1 = require("../../../components/RadioAndCheckbox");
var BlockLabel_1 = require("../BlockLabel");
var getBlockLabelProps_1 = require("../../../utils/getBlockLabelProps");
var styled_1 = require("./styled");
var TextInputs_1 = require("../TextInputs");
var __1 = require("../../..");
var DatePicker_1 = __importDefault(require("../DatePicker"));
function DateRangePicker_(props) {
    var onChange = props.onChange, value = props.value, id = props.id, readOnly = props.readOnly, futureDateOnly = props.futureDateOnly, previousDateOnly = props.previousDateOnly, allowPresentlyOngoing = props.allowPresentlyOngoing, invert = props.invert, disabled = props.disabled, debug = props.debug, startDateLabel = props.startDateLabel, endDateLabel = props.endDateLabel, _a = props.withPortal, withPortal = _a === void 0 ? false : _a;
    var _b = (0, react_1.useState)(value[0] || null), startDate = _b[0], setStartDate = _b[1];
    var _c = (0, react_1.useState)(value[1] || null), endDate = _c[0], setEndDate = _c[1];
    (0, react_1.useEffect)(function () {
        setStartDate(value[0] || null);
        setEndDate(value[1] || null);
    }, [value]);
    var currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    var yesterday = new Date(currentDate);
    yesterday.setDate(currentDate.getDate() - 1);
    var handleDateChange = function (index, date) {
        var newValue = __spreadArray([], value, true);
        newValue[index] = date;
        if (index === 0 && date && endDate && date > endDate) {
            newValue[1] = null;
        }
        onChange(id, newValue);
    };
    var getMinDate = function (isEndDate) {
        if (futureDateOnly) {
            return currentDate;
        }
        if (isEndDate && startDate) {
            return startDate;
        }
        return undefined;
    };
    var getMaxDate = function () {
        if (previousDateOnly) {
            return yesterday;
        }
        return undefined;
    };
    return (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: '0.2rem' } },
        react_1.default.createElement(BlockLabel_1.BlockLabel, __assign({}, (0, getBlockLabelProps_1.getBlockLabelProps)(props))),
        react_1.default.createElement(styled_1.StyledDateRangeInputWrapper, { invert: invert, readOnly: readOnly },
            react_1.default.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                react_1.default.createElement(DatePicker_1.default, { value: startDate, onChange: function (date) { return handleDateChange(0, date); }, id: "".concat(id, "-start"), readOnly: readOnly, disabled: disabled, withPortal: withPortal, portalId: "date-picker-portal-start", minDate: getMinDate(false), maxDate: getMaxDate(), pickerLabel: startDateLabel, debug: debug })),
            react_1.default.createElement(styled_1.StyledDateRangeInputDivider, null),
            react_1.default.createElement("div", { style: { display: "flex", flexDirection: "column" } }, value && value[1] === null ? (react_1.default.createElement("div", { style: { border: "1px solid ".concat(__1.colors2.grey20), padding: '8px 20px', borderRadius: '5px', width: '120px', background: "".concat(__1.colors2.grey5) } },
                react_1.default.createElement(TextInputs_1.TextInput, { value: "OnGoing", readOnly: true }))) : (react_1.default.createElement(DatePicker_1.default, { value: endDate, onChange: function (date) { return handleDateChange(1, date); }, id: "".concat(id, "-end"), readOnly: readOnly, disabled: disabled || (value && value[1] === null), withPortal: withPortal, portalId: "date-picker-portal-end", minDate: getMinDate(true), maxDate: getMaxDate(), pickerLabel: endDateLabel, debug: debug })))),
        !readOnly && allowPresentlyOngoing && (react_1.default.createElement("div", { style: { marginTop: '0.5rem' } },
            react_1.default.createElement(RadioAndCheckbox_1.CheckboxInput, { option: { display: 'Presently Ongoing', value: 'Ongoing' }, value: value && value[1] === null
                    ? [{ display: 'Presently Ongoing', value: 'Ongoing' }]
                    : [], onClick: function (isSelected) {
                    return handleDateChange(1, isSelected ? undefined : null);
                }, disabled: disabled || readOnly }))),
        debug && (react_1.default.createElement("pre", null, JSON.stringify({ startDate: startDate, endDate: endDate, value: value }, null, 2)))));
}
exports.DateRangePicker = react_1.default.memo(DateRangePicker_);
